import { FC } from 'react';
import { motion } from "framer-motion";
import './IALoader.scss';

interface IALoaderProps { }

const IALoader: FC<IALoaderProps> = () => {
  return (
    <div className="IALoader" data-testid="IALoader">
      <div className="d-flex align-items-center gap-1">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#333",
              display: "inline-block"
            }}
            animate={{ y: [0, -6, 0] }}
            transition={{
              repeat: Infinity,
              duration: 1,
              delay: i * 0.2,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default IALoader;
